// Compatibility shim for deprecated domain-task.
// We keep lightweight tracking so legacy action code can continue to call addTask().

const pendingTasks = new Set<Promise<unknown>>();

export function addTask<T>(task: Promise<T>): Promise<T> {
    if (task && typeof task.then === 'function') {
        pendingTasks.add(task as Promise<unknown>);
        task.finally(() => pendingTasks.delete(task as Promise<unknown>));
    }
    return task;
}

export function getPendingTasks(): Promise<unknown>[] {
    return Array.from(pendingTasks);
}
